export const permPlacementsListingRoutes = [
  {
    path: 'listing',
    name: 'perm-placements-listing',
    component: () =>
      import(/* webpackChunkName: "perm-placements-listing" */ './PermPlacementsListing.vue')
  },
  {
    path: 'create',
    name: 'create-perm-placement',
    component: () =>
      import(/* webpackChunkName: "create-perm-placement" */ '../new-perm-placement/NewPermPlacement.vue')
  }
];
